var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.55,
    height: 10.913,
    viewBox: "0 0 14.55 10.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_6144"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00efd1",
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(-902.239 -195.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visibility_3_",
    "data-name": "visibility (3)",
    transform: "translate(902.652 196.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6143",
    "data-name": "Path 6143",
    d: "M6.809,68.887A7.231,7.231,0,0,0,.023,73.856a.427.427,0,0,0,0,.275A7.231,7.231,0,0,0,6.809,79.1a7.231,7.231,0,0,0,6.786-4.969.427.427,0,0,0,0-.275,7.231,7.231,0,0,0-6.786-4.969Z",
    transform: "translate(0 -68.887)",
    fill: "#00a9e5"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6144-2",
    "data-name": "Path 6144",
    d: "M174.777,172.224a2.553,2.553,0,1,0,2.553,2.553A2.556,2.556,0,0,0,174.777,172.224Z",
    transform: "translate(-167.968 -169.671)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -0.41, -0.31)",
    filter: "url(#Path_6144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6144-3",
    "data-name": "Path 6144",
    d: "M174.777,172.224a2.553,2.553,0,1,0,2.553,2.553A2.556,2.556,0,0,0,174.777,172.224Z",
    transform: "translate(-167.55 -169.36)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "visibility_3_2",
    "data-name": "visibility (3)",
    transform: "translate(902.239 195.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6143-2",
    "data-name": "Path 6143",
    d: "M7.275,68.887A7.726,7.726,0,0,0,.024,74.2a.456.456,0,0,0,0,.294A7.726,7.726,0,0,0,7.275,79.8a7.726,7.726,0,0,0,7.251-5.309.456.456,0,0,0,0-.294,7.726,7.726,0,0,0-7.251-5.309Zm0,10A6.81,6.81,0,0,1,.937,74.343,6.81,6.81,0,0,1,7.275,69.8a6.81,6.81,0,0,1,6.338,4.547A6.81,6.81,0,0,1,7.275,78.89Z",
    transform: "translate(0 -68.887)",
    fill: "#083863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6144-4",
    "data-name": "Path 6144",
    d: "M174.952,172.224a2.728,2.728,0,1,0,2.728,2.728A2.731,2.731,0,0,0,174.952,172.224Zm0,4.547a1.819,1.819,0,1,1,1.819-1.819A1.821,1.821,0,0,1,174.952,176.771Z",
    transform: "translate(-167.677 -169.496)",
    fill: "#083863"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.9e4de7d4cbe9f1a223910d48cd802221.svg";
export { ForwardRef as ReactComponent };